import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { CONTACT_PHONE } from '@/helpers/constants';
import s from './index.module.scss';

export const WhatsAppChatLink = ({ className }) => {
  const phone = CONTACT_PHONE.replace('+', '').replaceAll(' ', '');
  const { t } = useTranslation('footer');

  return (
    <a
      href={`https://wa.me/${phone}`}
      className={classnames(s.link, className)}
      target="_blank"
      rel="noreferrer"
    >
      {t('message_us_whatsapp')}
    </a>
  );
};
